import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { BrowserTitleService } from '~src/commonInfra/services/BrowserTitleService';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { Location } from '~src/commonInfra/utils/Location';
import { ProjectDefinition } from '~src/projects/components/contentDefinitions/ProjectDefinition';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';
import { ExplorerEmptyStateProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerEmpyState';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

export interface BroadcastsSpaceStateProps {
    readonly urls: SpacesSiteUrls;
}

export interface BroadcastsSpaceOwnProps {
    readonly siteName: string;
}

export interface BroadcastsSpaceDispatchProps {
    readonly requestSpaceContents: () => void;
}

export type BroadcastsSpaceProps = BroadcastsSpaceStateProps
    & BroadcastsSpaceDispatchProps
    & BroadcastsSpaceOwnProps;


export class SiteBroadcastsSpace extends React.PureComponent<BroadcastsSpaceProps> {
    public componentDidMount() {
        this.props.requestSpaceContents();
        BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.broadcastsBrowserTitle() });
    }

    public render() {
        return (
            <div className={SpaceContainerStyles.SpaceContainer}>
                <div className={SpaceContainerStyles.MastheadArea}>
                    <div className={ExplorerStyles.SpaceHeaderContent}>
                        <div className={ExplorerStyles.SpaceHeaderText}>{Messages.broadcastsBrowserTitle()}</div>
                    </div>
                </div>
                <div className={SpaceContainerStyles.SubplaceArea}>
                    <ConnectedExplorer
                        supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
                        emptyStateProps={this.emptyStateProps()}
                        toolbarProps={{
                            supportFilterPanel: false,
                            toolbarVisibility: 'enabled'
                        }}
                    />
                </div>
            </div>
        );
    }

    private emptyStateProps(): ExplorerEmptyStateProps {
        return {
            iconUrl: imgPath('spaces_navigation_broadcasts.svg'), // TODO: change this when we have an empty broadcast icon
            primaryMessage: Messages.broadcastsEmptyStatePrimary(),
            secondaryMessage: Messages.broadcastsEmptyStateSecondary(),
            onActionButton: this.onNoContentAction,
            actionButtonMessage: Messages.emptyStateCallToAction()
        };
    }

    private onNoContentAction = (): void => {
        Location.instance.setUrl(this.props.urls.exploreUrl());
    };
}
